<div class="container">

  <!-- ======================= MOBILE VIEW ======================= -->
  <div class="mobile">
    <!-- Restriction information Section (Hidden on Desktop) -->
    <div class="restriction-card">
      <div class="info-header">Restriction Information</div>
      <div class="info-list">
        <div class="info"><label>Created Date: </label>{{ restricion?.dateCreated | date:'yyyy-MM-dd HH:mm'}}</div>
        <div class="info"><label>Latest Update:</label>{{ restricion?.dateUpdated | date:'yyyy-MM-dd HH:mm' }}</div>
        <div class="info"><label>Valid To: </label>{{ restricion?.validTo | date:'yyyy-MM-dd'  }}</div>
        <div class="info"><label>Responsible: </label>{{ restricion?.responsible }}</div>
        <div class="info"><label>Affected Product: </label></div>
        <div class="info"><label>Affected Vehicles: </label>{{ vehicleNames() }}</div>
        <div class="info"><label>Banned for Test Track: </label>{{ restricion?.banTestTrack ? 'Yes' : 'No' }}</div>
        <div class="info"><label>Banned for Public Road: </label>{{ restricion?.banPublicRoad ? 'Yes' : 'No' }}</div>
      </div>

      <div class="info-links">
        <!-- Links -->
        <div class="section-block">
          <div class="section-title">Links:</div>
          @if (restricion?.links) {
            <div class="section-item files-list">
              <div class="files-column">
                @for (link of (restricion?.links || '').split(','); track $index) {
                  <div class="file-row">
                    <a [href]="link.trim()" target="_blank">{{ link.trim() }}</a>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <!-- Documents (click to download) -->
        <div class="section-block">
          <div class="section-title">Documents:</div>
          @if (loadingFiles) {
            <div class="file-row"><span>Loading files…</span></div>
          } @else if (fileNamesDocuments.length) {
            <div class="section-item files-list">
              <div class="files-column">
                @for (doc of fileNamesDocuments; track $index) {
                  <div class="file-row">
                    <button
                      type="button"
                      class="link-like"
                      (click)="downloadByName(doc)"
                      title="Download {{ doc }}"
                    >
                      {{ doc }}
                    </button>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="file-row text-muted">No documents.</div>
          }
        </div>

        <!-- Images (click to preview in modal) -->
        <div class="section-block">
          <div class="section-title">Media:</div>
          @if (loadingFiles) {
            <div class="file-row"><span>Loading files…</span></div>
          } @else if (fileNamesImages.length) {
            <div class="section-item files-list">
              <div class="files-column">
                @for (img of fileNamesImages; track $index) {
                  <div class="file-row">
                    <button
                      type="button"
                      class="link-like"
                      (click)="previewImageByName(img)"
                      title="Preview {{ img }}"
                    >
                      {{ img }}
                    </button>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="file-row text-muted">No images.</div>
          }
        </div>

        <!-- Image Preview Dialog -->
        <p-dialog
          [(visible)]="showImagePreview"
          [modal]="true"
          [dismissableMask]="true"
          [baseZIndex]="1100"
          styleClass="image-preview-dialog"
          [style]="{ width: 'auto', maxWidth: '95vw' }"
          [contentStyle]="{ padding: '0', overflow: 'hidden' }"
          (onHide)="closeImagePreview()"
        >
          <ng-template pTemplate="header">
            {{ previewTitle || 'Image preview' }}
          </ng-template>

          <div class="image-preview-body">
            @if (loadingPreview) {
              <div class="file-row"><span>Loading image…</span></div>
            } @else if (previewSrc) {
              <img [src]="previewSrc" [alt]="previewTitle || 'Image'" class="image-preview" />
            } @else {
              <div class="file-row text-muted">Unable to load image.</div>
            }
          </div>
        </p-dialog>
      </div>
    </div>

    <!-- Details Section (Hidden on Desktop) -->
    <p-accordion [value]="['0', '1', '2', '3', '4', '5', '6', '7']" [multiple]="true">
      <p-accordion-panel value="0">
          <p-accordion-header>Restriction Contact Information</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.approvedBy"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="1">
          <p-accordion-header>Causing Part</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.cause"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="2">
          <p-accordion-header>Why is there a Risk</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.risk"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="3">
          <p-accordion-header>Consequence / Risk</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.consequence"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="4">
          <p-accordion-header>Who can use the vehicles with the risk stated</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.precondition"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="5">
          <p-accordion-header>How can vehicles be operated with this restriction</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.operatedRestriction"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="6">
          <p-accordion-header>When can this risk be removed?</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.removingCondition"></div></p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="7">
          <p-accordion-header>Additional Information</p-accordion-header>
          <p-accordion-content><div [innerHTML]="restricion?.additionalInformation"></div></p-accordion-content>
      </p-accordion-panel>
      @if (showFpc && restricion && restricion.fpcs?.length) {
        <p-accordion-panel value="8">
          <p-accordion-header>FPC</p-accordion-header>
          <p-accordion-content>
            @for (fpc of restricion.fpcs; track fpc.fpcId) {
              <div>{{ fpcLabel(fpc.fpcId, fpc.name) }}</div>
            }
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div><!-- .mobile -->

  <!-- ======================= DESKTOP VIEW ======================= -->
  <div class="desktop">
    <div class="restriction-content-grid">
      <!-- Left Card: Details -->
      <div class="restriction-details-card">
        <div class="details-row">
          <div class="details-label">Restriction Contact Information</div>
          <div class="details-input rich-text" [innerHTML]="restricion?.approvedBy"></div>
        </div>
        <div class="details-row">
          <div class="details-label">Causing Part</div>
          <div class="details-input rich-text" [innerHTML]="restricion?.cause"></div>
        </div>
        <div class="details-row">
          <div class="details-label">Why is there a Risk</div>
          <div class="details-input rich-text" [innerHTML]="restricion?.risk"></div>
        </div>
        <div class="details-row">
          <div class="details-label">Consequence / Risk</div>
          <div class="details-input rich-text" [innerHTML]="restricion?.consequence"></div>
        </div>
        <div class="details-row">
          <div class="details-label multiline">
            Who can use the vehicles with the risk stated
          </div>
          <div class="details-input rich-text" [innerHTML]="restricion?.precondition"></div>
        </div>
        <div class="details-row">
          <div class="details-label multiline">
            How can vehicles be operated with this restriction
          </div>
          <div class="details-input rich-text" [innerHTML]="restricion?.operatedRestriction"></div>
        </div>
        <div class="details-row">
          <div class="details-label multiline">
            When can this risk be removed?
          </div>
          <div class="details-input rich-text" [innerHTML]="restricion?.removingCondition"></div>
        </div>
        <div class="details-row">
          <div class="details-label">Additional Information</div>
          <div class="details-input rich-text" [innerHTML]="restricion?.additionalInformation"></div>
        </div>
        @if (showFpc) {
          <div class="details-row">
            <div class="details-label">FPC</div>
            <div class="details-input">
              @for (fpc of restricion?.fpcs; track fpc.fpcId) {
                <div>{{ fpcLabel(fpc.fpcId, fpc.name) }}</div>
              }
            </div>
          </div>
        }
      </div>

      <!-- Right Card: Info and Files -->
      <div class="restriction-info-card">
        <div class="info-header">Restriction Information</div>
        <div class="info-list">
          <div class="info"><label>Created Date: </label>{{ restricion?.dateCreated | date:'yyyy-MM-dd HH:mm'}}</div>
          <div class="info"><label>Latest Update:</label>{{ restricion?.dateUpdated | date:'yyyy-MM-dd HH:mm' }}</div>
          <div class="info"><label>Valid To: </label>{{ restricion?.validTo | date:'yyyy-MM-dd'  }}</div>
          <div class="info"><label>Responsible: </label>{{ restricion?.responsible }}</div>
          <div class="info"><label>Affected Product: </label></div>
          <div class="info"><label>Affected Vehicles: </label>{{ vehicleNames() }}</div>
          <div class="info"><label>Banned for Test Track: </label>{{ restricion?.banTestTrack ? 'Yes' : 'No' }}</div>
          <div class="info"><label>Banned for Public Road: </label>{{ restricion?.banPublicRoad ? 'Yes' : 'No' }}</div>
        </div>

        <div class="info-links">
          <!-- Links -->
          <div class="section-block">
            <div class="section-title">Links:</div>
            @if (restricion?.links) {
              <div class="section-item files-list">
                <div class="files-column">
                  @for (link of (restricion?.links || '').split(','); track $index) {
                    <div class="file-row">
                      <a [href]="link.trim()" target="_blank">{{ link.trim() }}</a>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Documents (click to download) -->
          <div class="section-block">
            <div class="section-title">Documents:</div>
            @if (loadingFiles) {
              <div class="file-row"><span>Loading files…</span></div>
            } @else if (fileNamesDocuments.length) {
              <div class="section-item files-list">
                <div class="files-column">
                  @for (doc of fileNamesDocuments; track $index) {
                    <div class="file-row">
                      <button
                        type="button"
                        class="link-like"
                        (click)="downloadByName(doc)"
                        title="Download {{ doc }}"
                      >
                        {{ doc }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="file-row text-muted">No documents.</div>
            }
          </div>

          <!-- Images (click to preview in modal) -->
          <div class="section-block">
            <div class="section-title">Media:</div>
            @if (loadingFiles) {
              <div class="file-row"><span>Loading files…</span></div>
            } @else if (fileNamesImages.length) {
              <div class="section-item files-list">
                <div class="files-column">
                  @for (img of fileNamesImages; track $index) {
                    <div class="file-row">
                      <button
                        type="button"
                        class="link-like"
                        (click)="previewImageByName(img)"
                        title="Preview {{ img }}"
                      >
                        {{ img }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="file-row text-muted">No images.</div>
            }
          </div>

          <!-- Image Preview Dialog -->
          <p-dialog
            [(visible)]="showImagePreview"
            [modal]="true"
            [dismissableMask]="true"
            [baseZIndex]="1100"
            [style]="{ width: 'min(90vw, 900px)' }"
            (onHide)="closeImagePreview()"
          >
            <ng-template pTemplate="header">
              {{ previewTitle || 'Image preview' }}
            </ng-template>

            <div class="image-preview-body">
              @if (loadingPreview) {
                <div class="file-row"><span>Loading image…</span></div>
              } @else if (previewSrc) {
                <img [src]="previewSrc" [alt]="previewTitle || 'Image'" class="image-preview" />
              } @else {
                <div class="file-row text-muted">Unable to load image.</div>
              }
            </div>
          </p-dialog>
        </div>
      </div>
    </div>
  </div><!-- .desktop -->
</div><!-- .container -->

